import React, { forwardRef } from "react";
import { TechnicalAnalysis } from "react-ts-tradingview-widgets";
import { SectionCard } from "../shared";

const TechnicalSection = forwardRef(({ code }, ref) => (
  <SectionCard ref={ref} id="technical" icon="tech" title="Technical Analysis">
    <div style={{ borderRadius: 12, overflow: "hidden", border: "1px solid #1e242e" }}>
      <TechnicalAnalysis
        key={code}
        symbol={`PSX:${code}`}
        colorTheme="dark"
        width="100%"
        height={450}
        isTransparent
        displayMode="multiple"
        showIntervalTabs
        interval="1D"
      />
    </div>
  </SectionCard>
));

export default TechnicalSection;
